import styled, { css } from 'styled-components'

import { ImageWithPlaceholder } from '@components/ImageWithPlaceholder'
import { NormalizedWrapper } from '@theme'

export const Wrapper = styled(NormalizedWrapper)`
  ${({ theme }) => css`
    margin-top: ${theme.newSpaces.xl5}px;

    ${theme.below.laptop`
      margin-top: ${theme.newSpaces.xl3}px;
      padding: 0 ${theme.newSpaces.sm}px;
    `}

    ${theme.below.mobileXL`
      margin-top: ${theme.newSpaces.sm}px;
      padding: 0 ${theme.newSpaces.xl}px;
    `}
  `}
`

export const ClientImage = styled(ImageWithPlaceholder)`
  display: block;
  height: 100%;
  margin: 0 auto;
  position: relative;
  width: 100%;
  z-index: 5;

  ${({ theme }) => css`
    margin-top: ${theme.newSpaces.lg}px;
  `}

  ${({ theme }) => theme.below.laptop`
    margin-top: ${theme.newSpaces.md}px;
  `}

  ${({ theme }) => theme.below.mobileXL`
    margin-top: ${theme.newSpaces.xs}px;
  `}
`
